// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useQuery } from '@tanstack/react-query';
import { getOrganization, listOrganizations } from '../../helios/services/omsService';
import type { OmsOrganization } from '../../helios/types/oms';

/**
 * Customer organizations, from the OMS route the BFF already exposes.
 *
 * Lives in `shared/` rather than `provisioning/` because the import boundary
 * keeps `services/` out of the app subtree (ADR-0014). Server state goes
 * through TanStack Query per ADR-0008.
 */
export function useOrganizations() {
  return useQuery<OmsOrganization[]>({
    queryKey: ['provisioning', 'organizations'],
    queryFn: () => listOrganizations(),
  });
}

/** One organization by id — for screens that need a single org (deep links
 * included) without depending on the unfiltered list query. */
export function useOrganization(orgId: string | undefined) {
  return useQuery<OmsOrganization>({
    queryKey: ['provisioning', 'organization', orgId],
    queryFn: () => getOrganization(orgId as string),
    enabled: !!orgId,
  });
}
